<template>
  <b-overlay :show="busy" rounded="sm">
    <!-- {{ item }} -->
    <b-card class="border-none py-0 mb-0 px-1">
      <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="mr-1"></i>
         {{ item.name }}
          
      </b-card-header>
      <b-card-body class="py-0">
        <b-row>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="From" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  size="sm"
                  v-model="datefrom"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="From"
                  :debounce="options.debounce"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>

                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!datefrom"
                    @click="datefrom = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" sm="6" md="4" xl="3">
            <b-form-group label-cols="12" label="To" label-size="sm">
              <b-input-group>
                <b-form-datepicker
                  size="sm"
                  v-model="dateto"
                  label-help
                  hide-header
                  locale="en-GB"
                  placeholder="To"
                  :debounce="options.debounce"
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                ></b-form-datepicker>

                <b-input-group-append>
                  <b-button
                    size="sm"
                    squared
                    variant="outline-secondary"
                    :disabled="!dateto"
                    @click="dateto = ''"
                  >
                    <i class="fa fa-remove"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-overlay
            :show="options.overlay_show"
            opacity=".9"
            v-click-outside="outside"
          >
            <div class="availtable datatable nested">
              <b-table
                :dark="$store.state.darkMode"
                ref="btable"
                sticky-header="350px"
                striped
                hover
                small
                caption-bottom
                show-empty
                :busy="busy"
                :items="items"
                :fields="options.fields"
                :filter="find"
                @row-clicked="rowClicked"
              >
                <template v-slot:table-busy>
                  <div class="text-center my-2">
                    <b-spinner
                      variant="primary"
                      class="align-middle mr-2"
                    ></b-spinner>
                    <strong class="text-primary">Loading...</strong>
                  </div>
                </template>
                <template v-slot:cell(icon)>
                  <i :class="options.icon" class="text-primary"></i>
                </template>
                <template v-slot:cell()="row">
                  <div
                    v-if="
                      options.badges &&
                      options.badges.find((obj) => obj.key == row.field.key)
                    "
                  >
                    <span
                      v-html="
                        $helpers.badgeField(
                          row.item,
                          options.badges.find(
                            (obj) => obj.key == row.field.key
                          ),
                          options
                        )
                      "
                    ></span>
                  </div>
                  <div v-else>{{ row.value }}</div>
                </template>
                <template v-if="options.actions" v-slot:cell(actions)="row">
                  <div id="actions-container" v-if="options.actions_as_elipses">
                    <b-button
                      variant="link"
                      size="sm"
                      title="Actions"
                      :id="'popover-target-' + row.item.id"
                      @click="$root.$emit('bv::hide::popover')"
                    >
                      <i class="fa fa-ellipsis-h text-primary"></i>
                    </b-button>
                    <b-popover
                      container="actions-container"
                      triggers="click blur"
                      placement="leftbottom"
                      :target="'popover-target-' + row.item.id"
                    >
                      <div>
                        <b-nav vertical>
                          <b-nav-item
                            :title="action.label"
                            v-for="action in $helpers.actionsValid(
                              row.item,
                              options
                            )"
                            :key="action.key"
                            @click.stop="table_action(action.key, row)"
                          >
                            <b-row class="px-2">
                              <b-col class="px-0">
                                <span class="text-normal">{{
                                  action.label
                                }}</span>
                              </b-col>
                              <b-col cols="1">
                                <i
                                  :class="action.icon"
                                  class="text-primary"
                                ></i>
                              </b-col>
                            </b-row>
                          </b-nav-item>
                        </b-nav>
                      </div>
                    </b-popover>
                  </div>
                  <div v-else>
                    <b-button
                      variant="link"
                      size="sm"
                      v-for="action in $helpers.actionsValid(row.item, options)"
                      :key="action.key"
                      @click.stop="table_action(action.key, row)"
                      :title="action.label"
                    >
                      <i :class="action.icon" class="text-primary"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <component
                      :is="options.component.name"
                      :search="search"
                      @discard="discard(row)"
                    ></component>
                  </b-card>
                </template>
              </b-table>
            </div>

            <template #overlay>
              <div class="text-center">
                <p id="cancel-label">{{ options.overlay.message }}</p>
                <hr />
                <b-row>
                  <b-col>
                    <b-button
                      v-for="(button, index) in options.overlay.buttons"
                      :key="index"
                      :style="button.style ? button.style : 'width: 80px'"
                      :class="
                        button.class
                          ? button.class
                          : button.dispatch
                          ? null
                          : 'ml-2'
                      "
                      :variant="
                        button.variant
                          ? button.variant
                          : button.dispatch
                          ? 'outline-primary'
                          : 'outline-secondary'
                      "
                      :size="button.size ? button.size : 'sm'"
                      :squared="button.squared ? button.squared : true"
                      @click="
                        button.dispatch
                          ? dispatcher(button.dispatch)
                          : (options.overlay_show = false)
                      "
                      >{{ button.label }}</b-button
                    >
                  </b-col>
                </b-row>
              </div>
            </template>
          </b-overlay>
          <b-row class="excelsheetbuttons px-1 mb-3">
            <b-col>
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin"></i>
                <span class="ml-1">Updating ...</span>
              </div>
              <span v-if="!busy">Found {{ items.length }} rows</span>
            </b-col>

            <b-col class="text-right">
              <b-link
                id="pnr-excel"
                class="mt-1 excel"
                @click="$helpers.outputExcel({ items })"
                title="Send to excel"
              >
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
              </b-link>
              <b-tooltip target="pnr-excel" triggers="hover"
                >Grid to excel</b-tooltip
              >
            </b-col>
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="my-2">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span class="text-primary">{{ message }}</span>
            </div>
          </b-col>
          <b-col cols="8" class="text-right">
            <b-button
              squared
              size="sm"
              variant="secondary"
              class="mr-1"
              @click="discard"
            >
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TaskSchedulerAudit",
  watch: {
    async datefrom() {
      await this.load();
    },
    async dateto() {
      await this.load();
    },
   
  },
  data() {
    return {
      toolbar_variant: "outline-primary",
      busy: false,
      items: [],
      item: {},
      datefrom: this.$moment().format("YYYY-MM-DD"),
      dateto: this.$moment().format("YYYY-MM-DD"),
      options: {
        title: "Task Scheduler Audit",
        icon: "fa fa-history text-warning",
        fields: [
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          // {
          //   key: "name",
          //   label: "Name",
          //   sortable: true,
          //   sortDirection: "desc",
          //   type: "text",
          // },

          {
            key: "updated_at",
            label: "Updated At",
            class: "d-none d-sm-table-cell w-110px",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "Never";
              if (value) {
                result = this.$moment
                  .unix(value / 1000)
                  .format("DD/MM/YYYY HH:mm:ss");
              }
              return result;
            },
          },

          {
            key: "data",
            label: "Data",
            sortable: true,
            sortDirection: "desc",
            type: "text",
            class: "text-left",
          },

          //   {
          //     key: "actions",
          //     label: "Actions",
          //     class: "actions w-120px",
          //   },
        ],
      },
    };
  },
  
  methods: {
    async load() {
      this.busy = true;
      let variables = {
        id: this.idselected,
       
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query tasksAt($id: String) {
              tasksAt(id: $id) {
                id
                name
                history {
                  updated_at
                  data
                }
              }
            }
          `,
          variables,
        });

        if (response.data.tasksAt.length > 0) {
          this.item = response.data.tasksAt[0];
          this.items = this.item.history
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    
  },
};
</script>

<style>
</style>